// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';
import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';

export const updateSystemSelectedClaimsModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.UPDATE_TCSM_PREPARE_AUDIT_SYSTEM_SELECTED_CLAIMS_MODAL_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/action-creators/system-selected-claims-modal-visibility.js